<template>
  <InPlayerVideoOverlay>
    <OverlayContent>
      <template slot="title">
        {{ $t('title') }}
      </template>

      <template slot="message">
        {{ $t('message') }}
      </template>

      <DownloadAppButton
        slot="content"
        :overlay="true"
        :tracker="getAnalyticPayload(e => e.player['overlay-app-gate'].click.action, video.id)"
        @click="performAction({
          tracker: {
            label: 'open-in-app',
          } });"
      >
        {{ $t('cta') }}
      </DownloadAppButton>
    </OverlayContent>

    <FooterAction
      slot="footer"
      :tracker="getAnalyticPayload(e => e.player['overlay-app-gate'].click.close, video.id)"
      @click="() => dismiss({ autoplay: true })"
    >
      {{ $t('skipThis') }}
    </FooterAction>
  </InPlayerVideoOverlay>
</template>

<script lang="ts">
import { getAnalyticPayload } from '@/scripts/libs/analytic';
import DownloadAppButton from '@/scripts/Components/Molecules/DownloadAppButton.vue';
import { VideoPlayerOverlayBase } from '../layout/VideoPlayerOverlayBase';
import InPlayerVideoOverlay from '../layout/InPlayerVideoOverlay.vue';
import OverlayContent from '../components/OverlayContent.ts.vue';
import OverlayButton from '../components/OverlayButton.ts.vue';
import FooterAction from '../components/FooterAction.ts.vue';

export default VideoPlayerOverlayBase.extend({
  i18n: {
    en: {
      title: 'Try the Viddsee App',
      message: 'Enjoy faster streaming, download and more!',
      cta: 'Watch in App',
      skipThis: 'Skip',
    },
    id: {
      title: 'Cobalah Viddsee App',
      message: 'Nikmati streaming yang lebih lancar, unduh, dan lainnya!',
      cta: 'Tonton di App',
      skipThis: 'Lewati',
    },
    zh: {
      title: '查看 Viddsee App',
      message: '享受流暢影片播放，下載及更多！',
      cta: '以 App 觀賞',
      skipThis: '跳過',
    },
  },
  components: {
    DownloadAppButton,
    InPlayerVideoOverlay,
    OverlayContent,
    OverlayButton,
    FooterAction,
  },
  data() {
    return {
      dataBranch: {
        channel: 'player',
        feature: 'player',
        campaign: 'app-campaign',
        data: {
          // eslint-disable-next-line @typescript-eslint/camelcase
          $deeplink_path: 'video/' + this.video.id,
          // eslint-disable-next-line @typescript-eslint/camelcase
          $desktop_url: `${location.origin}/mobile`,
        },
      },
    };
  },

  methods: {
    getAnalyticPayload,
  },
});
</script>
